import React, { useCallback, useRef } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import SearchOutlined from '@material-ui/icons/SearchOutlined';
import { useTranslation } from 'react-i18next';

const SearchInput = styled.input`
    border: none;
    outline: none;
    border-radius: 20px;
    width: 200px;
    height: 40px;
    background-color: white;
    color: grey;
    padding: 10px 35px 10px 10px;
`;

const SearchIcon = styled(SearchOutlined)`
    color: black;
    position: absolute;
    margin-left: -35px;
    height: 100%;
    width: 30px;
    &:hover{
      opacity: 0.6;
    }
`;

export default () => {
  const inputRef = useRef(null);
  const history = useHistory();
  const { t } = useTranslation();

  const startSearching = useCallback((e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    const searchString = inputRef.current.value;
    if (searchString) history.push(`/ec/search?searchable=${searchString}`);
    else history.push('/ec/search');
  }, [inputRef, history]);

  const handleKeyDown = useCallback((e) => {
    if (e.keyCode === 13) {
      startSearching();
    }
  }, [startSearching]);

  return (
    <div className="fz-relative">
      <SearchInput
        placeholder={t('ec.search_hint')}
        onKeyDown={handleKeyDown}
        ref={(ref) => { inputRef.current = ref; }}
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
      />
      <SearchIcon onClick={startSearching} />
    </div>
  );
};
